<div class="switch-wrapper" [formGroup]="form">
    <div class="switch">
        <input type="checkbox" [id]="id" class="checkbox" [checked]="checked" [formControlName]="id"/>
        <label [for]="id" class="toggle">
            <p>&nbsp;</p>
            <p>&nbsp;</p>
        </label>
    </div>
    <label class="label">{{label}}</label>
</div>
